import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "services";
import * as Actions from "actions";
import { TextEditor } from "constants/Actions";
import { i18n } from "us.helper";
import { $Message, $MessageBox } from "us.common/components";
import _ from "lodash";
import { TextData } from "interfaces/TextEditor";

const { textEditor, editorHome } = Actions;
const { text } = API.TextEditor;

const { adapters } = API.templateEditor;

const { SAVE_TEXT_DATA, GET_STANDARD_ADAPTERS, DELETE_TEXT_DATA } = TextEditor;

const textEditorSagas = {
  text: {
    save: function* (action: any) {
      try {
        $Message.loading(i18n.t("COMMON.SAVING") as string, 0);
        const { request, texts } = action?.payload.data ?? {};
        const { data, status } = yield call(text.save, request);
        $Message.destroy();
        let objectIndex = -1;
        if (texts && Array.isArray(texts)) {
          objectIndex = texts.findIndex((text: any) => text.id == request.id);
        }
        if (status === 200) {
          yield put(textEditor.textData.success(data));
          $MessageBox(
            "success",
            `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_SAVED_SUCCESSFULLY`,
            "",
            ""
          );
          if (objectIndex === -1) {
            yield put(editorHome.texts.success([...texts, request]));
            return;
          } else {
            const newData = [...texts];
            newData[objectIndex] = request;
            yield put(editorHome.texts.success(newData));
          }
        } else if (status === 401) {
          yield put(textEditor.textData.fail(data));
          if (objectIndex === -1) {
            $MessageBox(
              "error",
              `US.USC.TEMPLATEEDITOR:MESSAGES.YOU_ARE_NOT_ALLOWED_TO_ADD_TEXTS`,
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              `US.USC.TEMPLATEEDITOR:MESSAGES.YOU_ARE_NOT_ALLOWED_TO_UPDATE_TEXTS`,
              "",
              ""
            );
          }
        } else {
          yield put(textEditor.textData.fail({}));
          $MessageBox(
            "error",
            `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_SAVE_FAILED`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(textEditor.textData.fail({}));
        $MessageBox(
          "error",
          `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_SAVE_FAILED`,
          "",
          ""
        );
      }
    },
    delete: function* (action: any) {
      try {
        const { request, texts } = action?.payload.data ?? {};
        const { data, status } = yield call(text.delete, request);
        if (status === 200) {
          yield put(textEditor.text.success(data));
          $MessageBox(
            "success",
            `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_DELETED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(
            editorHome.texts.success(
              texts.filter(
                (textDetail: TextData) => textDetail.id != request.textId
              )
            )
          );
        } else if (status == 401) {
          yield put(textEditor.text.fail(data));
          $MessageBox(
            "error",
            `US.USC.TEMPLATEEDITOR:MESSAGES.YOU_ARE_NOT_ALLOWED_TO_DELETE_TEXTS`,
            "",
            ""
          );
        } else {
          yield put(textEditor.text.fail({}));
          $MessageBox(
            "error",
            `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_DELETION_FAILED`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(textEditor.text.fail({}));
        $MessageBox(
          "error",
          `US.USC.TEMPLATEEDITOR:MESSAGES.TEXT_DELETION_FAILED`,
          "",
          ""
        );
      }
    },
  },
  standardAdapter: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(adapters.byCategoryId, params);
        if (status == 200) {
          yield put(textEditor.adapter.success(data));
        } else {
          yield put(textEditor.adapter.success([]));
        }
      } catch (error) {
        yield put(textEditor.adapter.fail([]));
      }
    },
  },
};

export default [
  takeLatest(SAVE_TEXT_DATA, textEditorSagas.text.save),
  takeLatest(GET_STANDARD_ADAPTERS, textEditorSagas.standardAdapter.get),
  takeLatest(DELETE_TEXT_DATA, textEditorSagas.text.delete),
];
